export default "__VITE_ASSET__CHXAZMEV__"